//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Osteoporosis_Risk_One_Minute_Question",
  data() {
    return {
      form: {
        value1: "0",
        value2: "0",
        value3: "0",
        value4: "0",
        value5: "0",
        value6: "0",
        value7: "0",
        value8: "0",
        value9: "0",
      },
      hasScore: false,
      disabled: false,
     

    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false;
        return "...";
      } else {

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Osteoporosis_Risk_One_Minute_Question.vue